import React from "react"
import SearchPageWithStore from "../../components/SearchPage/SearchPageWithStore"
import PropTypes from "prop-types"

const SearchPageView = props => {
  return (
    <SearchPageWithStore
      facilityId={props.match.params.facilityId}
      {...props}
    />
  )
}

SearchPageView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      facilityId: PropTypes.string,
    }),
  }),
}

export default SearchPageView
